import { Outlet } from 'react-router-dom';

import { Button } from '@domcrm/embed-ui';

import { fetchPublicLegalDocuments, type PublicLegalDocuments } from '../widget-api/public-legal-documents';
import { useEmbedBootstrap } from '../use-widget-bootstrap';
import { useAsync } from '../widget-hooks/useAsync';
import { EmbedMessageBlock } from '../widget-ui/embed-message-block';

export type LegalDocumentsOutletContext = { data: PublicLegalDocuments };

export default function LegalDocumentsOutlet() {
  const { orgSlug } = useEmbedBootstrap();
  const { data, loading, error, reload } = useAsync(
    () => fetchPublicLegalDocuments(orgSlug),
    [orgSlug]
  );

  if (loading) {
    return (
      <div className="w-full min-w-0 px-4 py-4">
        <p className="text-sm text-[var(--text-muted)]">Загрузка…</p>
      </div>
    );
  }
  if (error) {
    return (
      <div className="space-y-3 w-full min-w-0 px-4 py-4">
        <EmbedMessageBlock variant="error" size="field" role="alert" aria-live="assertive">
          {error}
        </EmbedMessageBlock>
        <Button type="button" variant="secondary" onClick={() => reload()}>
          Повторить
        </Button>
      </div>
    );
  }
  if (!data) {
    return null;
  }
  return <Outlet context={{ data } as LegalDocumentsOutletContext} />;
}
